<template>
    <el-container>
        <fhead></fhead>
        <el-main>
            <el-breadcrumb class="center" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">{{$t('l.home')}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{$t('l.fhead.peers')}} Map</el-breadcrumb-item>
            </el-breadcrumb>
            <el-card v-loading="Loading"
                     class="box-card center" style="margin-top: 16px">
                <iframe id="Box" frameborder="no" :src="$store.state.iframe+'static/peer3d.html'" width="100%"
                        height="600px"></iframe>
            </el-card>
        </el-main>
        <el-footer class="footer">
            COPYRIGHT © 2018. ALL RIGHTS RESERVED. DESIGNED BY
            <a target="_blank" href="https://hebeblock.com/">HEBEBLOCK</a>
        </el-footer>
    </el-container>
</template>


<script>
    import fhead from '../fhead.vue';

    export default {
        name: 'peersMap',
        data() {
            return {
                Loading: true,
            }
        },
        components: {
            fhead
        },
        mounted: function () {
            var iframe = document.getElementById("Box");
            iframe.onload = () => {
                this.Loading = false
            };
        }


    }
</script>


<style scoped>
</style>  


// WEBPACK FOOTER //
// src/components/peer/peers3d.vue